import React, { useContext, useState } from 'react'
import './preview.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom';
import { ShareContext } from '../../context/ShareContext'

function Preview() {
    const documents = [
        {
            id: 0,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: true
        },
        {
            id: 1,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: false
        },
        {
            id: 3,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: true
        },
        {
            id: 4,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: true
        },
        {
            id: 5,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: false
        },
        {
            id: 6,
            refId: 'FRT567G',
            docTitle: 'Statement of Compliance with pre-action protocol',
            caseNum: 2538,
            isOathed: true
        }
    ]

    const { whichUpload } = useContext(ShareContext)
    
    const [openDialog, setOpenDialog] = useState(false)

    const navigate = useNavigate();

    const submit = (e) => {
        e.preventDefault();

        setOpenDialog(true)
    }

  return (
    <div className='preview'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Final Preview of Documents</h2>
                    </div>
                    <p>Preview and edit documents uploaded before the final submission</p>
                </div>
                <p className="nav-status">Home/Specifications/Documents-Preview</p>
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Document Reference ID</th>
                            <th>Document Title</th>
                            <th>Case Number</th>
                            <th>Oath</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            documents.map((item, id) => { return (
                                <tr key={id}>
                                    <td>{item.refId}</td>
                                    <td>{item.docTitle}</td>
                                    <td>{item.caseNum}</td>
                                    <td className={ item.isOathed ? 'oath' : 'oath pend'}>{item.isOathed ? 'Yes' : 'Pending'}</td>
                                    <td>
                                        <div className="view-btn">
                                            <p>View</p>
                                            <button className='black'>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            )})
                        }
                    </tbody>
                </table>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => navigate('/upload/documents') }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Upload</p>
                </div>
                <button className="red" onClick={submit}>
                    Submit <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
        </div>
        <div className={ openDialog ? "dialog-box open" : "dialog-box"}>
            {whichUpload === 'First' && <div className="wrapper">
                <h3>UPLOADS SUCCESSFUL</h3>
                <div className="main">
                    <p>Congratulations, the uploads were successful</p>
                    <button onClick={() =>  navigate('/')} className='red'>Continue to JIS <FontAwesomeIcon icon={faArrowRight} /></button>
                </div>
            </div>}
            {
                whichUpload === 'Second' && 
                <div className="wrapper">
                <h3>UPLOADS SUCCESSFUL</h3>
                <div className="main">
                    <p>Congratulations, the uploads were successful. You opted for your document(s) to be commissioned through e-Swearing, Kindly wait for the CFO to schedule your files for commissioning. To see the wait list click on e-Swearing Button.</p>
                    <div className="btns">
                        <button onClick={() =>  navigate('/upload/e-swearing') } className='red'>e-Swearing</button>
                        <button onClick={() =>  navigate('/')} className='red'>Continue to JIS <FontAwesomeIcon icon={faArrowRight} /></button>
                    </div>  
                </div>
            </div>
            }
            
        </div>
    </div>
  )
}

export default Preview